import { useState } from "react"
import { useLocale } from "../components/LocaleProvider"
import { Tabs, TabsList, TabsTrigger } from "../components/ui/tabs"
import Profiles from "./Profiles"
import Listings from "./Listings"
import Jobs from "./Jobs"

type MatchingTab = "profiles" | "listings" | "jobs"

function Matching() {
  const { t } = useLocale()
  const [tab, setTab] = useState<MatchingTab>("profiles")

  return (
    <div>
      <div className="p-6 pb-0">
        <Tabs value={tab} onValueChange={(v) => setTab(v as MatchingTab)}>
          <TabsList>
            <TabsTrigger value="profiles">{t("nav_profiles")}</TabsTrigger>
            <TabsTrigger value="listings">{t("nav_listings")}</TabsTrigger>
            <TabsTrigger value="jobs">{t("nav_jobs")}</TabsTrigger>
          </TabsList>
        </Tabs>
      </div>
      {tab === "profiles" && <Profiles />}
      {tab === "listings" && <Listings />}
      {tab === "jobs" && <Jobs />}
    </div>
  )
}

export default Matching
